import { FormsFeatureContext } from '@ngt/forms';
import { useCallback, useContext } from 'react';
import { StagePricelistDownload, SubStages } from '../../api/dtos';

const usePricelistDownloadByStageIdSubstage = () => {
    const formsFeature = useContext(FormsFeatureContext);
            
    const download = useCallback(async (stageId?: number, subStage?: SubStages) => {
        const response = await formsFeature.serviceStackClient.get(
            new StagePricelistDownload({ 
                stageId,
                subStage
            }))

        return response;
    }, [formsFeature.serviceStackClient]);

    return download;
}

export default usePricelistDownloadByStageIdSubstage;